"use strict";
var IPromptComponent;
(function (IPromptComponent) {
    var PromptButton;
    (function (PromptButton) {
        PromptButton[PromptButton["Unselected"] = 0] = "Unselected";
        PromptButton[PromptButton["Yes"] = 1] = "Yes";
        PromptButton[PromptButton["No"] = 2] = "No";
    })(PromptButton = IPromptComponent.PromptButton || (IPromptComponent.PromptButton = {}));
})(IPromptComponent || (IPromptComponent = {}));
module.exports = IPromptComponent;
